import {AuctionSettings, Codes, Dealer, Notification, User, WebSocketSettings} from 'domain-models'
import {SubjectType} from 'redux/actions'
import {Translations} from '../../filters'

export type AppState = {
    dealers: Array<Dealer>
    subjectType: SubjectType
    basename: string
    auctionV2: {
        redirect: boolean
        url: string
    }
    releaseStage: 'local' | 'production' | 'development'
    user: User
    codes: Codes
    settings: AuctionSettings
    socket: WebSocketSettings
    notifications: {
        announcements: Array<Notification>
        notifications: Array<Notification>
    }
    unreadNotifications: number
    translations: Translations
    locale: 'de' | 'en' | 'fr'
}

type AppAction = {
    type: string
    app: AppState
}

const initialState = {
    ...window.app
}

const appReducer = (state: AppState = initialState, action: AppAction) => {
    switch (action.type) {
        case 'UPDATE_APP':
            return {
                ...action.app
            }
        default:
            return state
    }
}

export default appReducer
